import { IUserState } from 'Redux/Slices/User/UserSlice';
import { Draft, PayloadAction } from '@reduxjs/toolkit';

export const setBearerToken = (state: Draft<IUserState>, { payload }: PayloadAction<{ token: string|null }>) => {
  state.updatedAt = Date.now();
  state.token = payload.token;
};
